import BaseComponent from './_BaseComponent'



/* Wall
----------------------------------------------------------------------------------------------------*/

export default class Dropdown extends BaseComponent {

    constructor($el, namespace) {
        super('Dropdown', $el, namespace)


        this.on()
    }

    bindProperties() {

    }


    bindHandlers() {
        this.changeHandler = e => this.onChange(e)
    }


    bindEvents() {
        const { $select } = this.$refs

        this.addListeners(
            [$select, 'change', this.changeHandler],
        )
    }


    /* Handlers
    --------------------------------------------------------- */

    onChange(e) {
        const { selectedIndex } = e.currentTarget.options
        const options = [...e.currentTarget.options]
        const selectedValue = options[selectedIndex].innerText

        this.$refs.label.text(selectedValue)
    }



    /* Actions
    --------------------------------------------------------- */



    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



